module.exports = __webpack_public_path__ + "img/Timer.b38ab9ed.svg";